<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ "US Profile Config" }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the current us profile config." }}
      </p>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <block-cntr :btitle="'US Profile Config'" style="height: 410px">
          <div class="form-inline">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="isShowAddTable = true"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-plus page-tableaction"></i>
                </div>
                  <div
                  @click="clkEdit()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-edit page-tableaction"></i>
                </div>

                <div
                  @click="clkDel()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-trash-o page-tableaction"></i>
                </div>
              </div>
            </span>
          </div>

          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th width="40px">
                  <input
                    type="checkbox"
                    v-model="isSelectAll"
                    @change="changeSelectAll()"
                    id="idSelectAll"
                  />
                  <label for="idSelectAll"></label>
                </th>
                <th v-for="(value, key) in title" :key="key" :title="value">
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, index) in usTable"
                :key="row.profileId"
                :class="{ 'true:': true }"
                @click="changeSelect(row)"
              >
                <td width="40px">
                  <div @click.stop="" v-if="!row.isNew">
                    <input
                      type="checkbox"
                      v-model="row.selected"
                      :id="'idRowSelect' + index"
                    />
                    <label :for="'idRowSelect' + index"></label>
                  </div>
                </td>
                <td>
                  <div>{{ row.profileId }}</div>
                </td>
                <td>
                  <div>{{ row.profileName }}</div>
                </td>
                <td>
                  <div>{{ row.queuePri }}</div>
                </td>
                <td>
                  <div>{{ row.usCir }}</div>
                </td>
                <td>
                  <div>{{ row.usPir }}</div>
                </td>
                <td>
                  <div>{{ row.usCbs }}</div>
                </td>
                <td>
                  <div>{{ row.usPbs }}</div>
                </td>
              </tr>
            </tbody>
          </table>

          <div v-if="isShowAddTable">
            <dialog-box
              :btitle="'Us Profile Edit'"
              @close="clkCancel()"
              style="min-height: 410px"
            >
              <form class="form-horizontal" role="form">
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="profileId">{{
                    title.profileId
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(1)}">
                    <input
                      type="text"
                      class="form-control"
                      id="profileId"
                      :disabled="isEditClik"
                      v-model="usForm.profileId"
                      autocomplete="off"
                      :placeholder=" 'INTEGER<0-' + profileMaxNum + '>'"
                    />
                     <small
                        class="help-block"
                        :style="{
                          display: input_para_check(1) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(1) }}
                      </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="name">{{
                    title.profileName
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(6) }">
                    <input
                      type="text"
                      class="form-control"
                      id="name"
                      maxlength="128"
                      v-model="usForm.profileName"
                      autocomplete="off"
                      placeholder="STRING<1-128>"
                    />
                     <small
                        class="help-block"
                        :style="{
                          display: input_para_check(6) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(6) }}
                      </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="carmode"
                    >Car Mode</label
                  >
                  <div class="col-sm-5">
                    <select
                      class="form-control"
                      id="carmode"
                      :disabled="isEditClik"
                      v-model="usForm.carMode"
                    >
                      <option value="1">Queue</option>
                      <option value="0">Car</option>
                    </select>
                  </div>
                </div>

                <div v-if="usForm.carMode == '1'" class="form-group">
                  <label class="col-sm-3 control-label" for="queuepri">{{
                    title.queuePri
                  }}</label>
                  <div class="col-sm-5">
                    <select
                      class="form-control"
                      id="queuepri"
                      v-model="usForm.queuePri"
                    >
                      <option value="" disabled selected style="display: none">
                        please choose..
                      </option>
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                    </select>
                  </div>
                </div>
                <div v-if="usForm.carMode == '0'" class="form-group">
                  <label class="col-sm-3 control-label" for="cir">{{
                    title.usCir
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(2)}">
                    <input
                      type="text"
                      class="form-control"
                      id="cir"
                      v-model="usForm.usCir"
                      placeholder="INTEGER<64-1200000>(kbps)"
                    />
                     <small
                        class="help-block"
                        :style="{
                          display: input_para_check(2) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(2) }}
                      </small>
                  </div>
                </div>

                <div v-if="usForm.carMode == '0'" class="form-group">
                  <label class="col-sm-3 control-label" for="pir">{{
                    title.usPir
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(3)}">
                    <input
                      type="text"
                      class="form-control"
                      id="pir"
                      v-model="usForm.usPir"
                      placeholder="INTEGER<64-1200000>(kbps)"
                    />
                     <small
                        class="help-block"
                        :style="{
                          display: input_para_check(3) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(3) }}
                      </small>
                  </div>
                </div>

                <div v-if="usForm.carMode == '0'" class="form-group">
                  <label class="col-sm-3 control-label" for="cbs">{{
                    title.usCbs
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(4)}">
                    <input
                      type="text"
                      class="form-control"
                      id="cbs"
                      v-model="usForm.usCbs"
                      placeholder="INTEGER<2-37500>(kbytes)"
                    />
                     <small
                        class="help-block"
                        :style="{
                          display: input_para_check(4) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(4) }}
                      </small>
                  </div>
                </div>

                <div v-if="usForm.carMode == '0'" class="form-group">
                  <label class="col-sm-3 control-label" for="pbs">{{
                    title.usPbs
                  }}</label>
                  <div class="col-sm-5" :class="{ 'has-error': input_para_check(5)}">
                    <input
                      type="text"
                      class="form-control"
                      id="pbs"
                      v-model="usForm.usPbs"
                      placeholder="INTEGER<2-37500>(kbytes)"
                    />
                     <small
                        class="help-block"
                        :style="{
                          display: input_para_check(5) ? 'block' : 'none',
                        }"
                        >{{ input_para_check(5) }}
                      </small>
                  </div>
                </div>

                <button
                  type="button"
                  class="btn btn-primary"
                  style="
                    margin-left: 20%;
                    min-width: 77px;
                    color: #fff;
                    background-color: #008b8b;
                    border-color: #008080;
                  "
                  @click="clkApply()"
                >
                  {{ "Apply" }}
                </button>
                <span style="margin-left: 10px">
                  <button
                    type="button"
                    class="btn btn-default"
                    style="min-width: 77px"
                    @click="clkCancel()"
                  >
                    {{ "Cancel" }}
                  </button>
                </span>
              </form>
            </dialog-box>
          </div>
        </block-cntr>
      </div>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>


<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import { get, post } from "@/utils/http.js"
import InfoBox from "./../components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { nonASCIIchar } from "@/utils/check.js"



export default {
  name: "profileUs",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },

  data() {
    return {
      title: {},
      isShowAddTable: false,
      isEditClik: false,
      isSelectAll: false,
      watchFlag: true,
      iBox: {},
      select: [],
      usForm: {
        profileId: "",
        profileName: "",
        queuePri: "",
        usCir: "",
        usPir: "",
        usCbs: "",
        usPbs: "",
        carMode: "0",
      },

      usTable: [],
      profileMaxNum:"2047",
    }
  },

  created() {
    this.loadUsProfile()
    this.loadProfileNum()
  },

  watch:{
    'usForm.carMode':function(){
        if(this.watchFlag)
        {
          this.usForm.queuePri = ""
          this.usForm.usCir = ""
          this.usForm.usPir = ""
          this.usForm.usCbs = ""
          this.usForm.usPbs = ""
        }

        this.watchFlag = true
    }
  },

  methods: {
    loadUsProfile() {
      get("profileus")
        .then((res) => {
          this.usTable = res.data.data
          this.title = res.data.title
        })
        .catch((err) => {
          console.log(err)
        })
    },

    loadProfileNum() {
      get("profilemaxnum")
        .then((res) => {
          this.profileMaxNum = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },

    clkCancel() {
      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    resetField() {
      var dbaformTmp = {
        profileId: "",
        profileName: "",
        queuePri: "",
        usCir: "",
        usPir: "",
        usCbs: "",
        usPbs: "",
        carMode: "0",
      }

      this.usForm = dbaformTmp
    },

    profileSortFun(a, b) {
      return Number(a.profileId) - Number(b.profileId)
    },

    clkApply() {
      var newProfile = {
        profileId: Number(this.usForm.profileId),
        profileName: this.usForm.profileName,
        queuePri: Number(this.usForm.queuePri),
        usCir: Number(this.usForm.usCir),
        usPir: Number(this.usForm.usPir),
        usCbs: Number(this.usForm.usCbs),
        usPbs: Number(this.usForm.usPbs),
        operate: 1,
      }

      if(this.usForm.profileId == "")
      {
        this.showAlertBox(
              "warn",
              "Message",
              "Invalid profileID"
          )
         return 
      }

      var msg = this.input_para_check(0)
      if( msg != null)
      {
          this.showAlertBox(
              "warn",
              "Message",
              msg
          )
          return
      }

      if (this.usForm.carMode == "1") newProfile.usCir = 0
      if (!this.isEditClik) {
        for (let i = 0; i < this.usTable.length; i++) {
          if (this.usTable[i].profileId == newProfile.profileId) {
            this.showAlertBox(
              "warn",
              "Message",
              "this profile id has been existed,please choose a new one"
            )
            return
          }
        }
      }

      post("profileus", newProfile)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.showAlertBox("info", "Info", "Config successful!")
            this.loadUsProfile()
            /*if (newProfile.usCir != 0) {
              newProfile.queuePri = ""
            } else {
              newProfile.usCir = ""
              newProfile.usPir = ""
              newProfile.usCbs = ""
              newProfile.usPbs = ""
            }

            if (this.isEditClik) {
              let editindex = this.select[0]
              this.usTable[editindex]= newProfile
            }
            else
            {
              this.usTable.push(newProfile)
              this.usTable.sort(this.profileSortFun)
            }*/
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })

      this.resetField()
      this.isShowAddTable = false
      this.isEditClik = false
    },

    clkEdit() {
      for (let i = 0; i < this.usTable.length; i++) {
        if (this.usTable[i].selected) {
          this.usForm.profileId = this.usTable[i].profileId
          if(this.usTable[i].profileName.match(/^INDEX_/) == null)
          {
             this.usForm.profileName = this.usTable[i].profileName
          }
          
          this.usForm.queuePri = this.usTable[i].queuePri
          this.usForm.usCir = this.usTable[i].usCir
          this.usForm.usPir = this.usTable[i].usPir
          this.usForm.usCbs = this.usTable[i].usCbs
          this.usForm.usPbs = this.usTable[i].usPbs
          if(this.usTable[i].usCir != "")
            this.usForm.carMode  = '0'
          else
            this.usForm.carMode  = '1'
          this.watchFlag = false
          this.isShowAddTable = true
          this.isEditClik = true
          this.select[0] = i
          return
        }
      }
    },

    clkDel() {
      var errflag = 0
      var del = []
      var i
      var id = []
      var newProfile = {
        profileId: 0,
        operate: 2,
      }

      for (i = 0; i < this.usTable.length; i++) {
        if (this.usTable[i].selected) {
          newProfile.profileId = Number(this.usTable[i].profileId)
          del.push(post("profileus", newProfile))
          id.push(this.usTable[i].profileId)
        }
      }

      if (del.length == 0) {
        return
      }

      Promise.all(del)
        .then((res) => {
          res.forEach((element, index) => {
            if (
              element.data == undefined ||
              element.data.code === undefined ||
              element.data.code === 0
            ) {
              for (i = 0; i < this.usTable.length; i++) {
                if (this.usTable[i].profileId == id[index]) {
                  this.usTable.splice(i, 1)
                  break
                }
              }
            } else {
              this.showAlertBox("warn", "Message", element.data.msg)
              errflag = 1
            }
          })
          if (errflag === 0)
            this.showAlertBox("info", "Info", "Delete successful!")
        })

        .catch((err) => {
          console.log(err)
          this.showAlertBox("critical", "error", err)
        })
    },

    changeSelectAll() {
      for (let i = 0; i < this.usTable.length; i++) {
        if (this.isSelectAll) {
          this.$set(this.usTable[i], "selected", true)
        } else {
          this.$set(this.usTable[i], "selected", false)
        }
      }
    },

    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },

    changeSelect(row) {
      console.log(row)
      if (row.selected == undefined) {
        this.$set(row, "selected", true)
      } else row.selected = !row.selected
    },

    input_para_check(value)
    {
      if(value == 1 || value == 0)
      {
        if(this.usForm.profileId != "")
        {
            let profileid = Number(this.usForm.profileId)
            if(!isNaN(profileid))
            {
                if(profileid < 0 || profileid > Number(this.profileMaxNum))
                return "profile id must be in range 0-"+ this.profileMaxNum
            }
            else
              return "profile id must be in range 0-"+ this.profileMaxNum
        }
      }

      if(value == 2 || value == 0)
      {
        if(this.usForm.usCir != "")
        {
            let usCir = Number(this.usForm.usCir)
            if(!isNaN(usCir))
            {
                if(usCir < 64 || usCir > 1200000)
                return "Cir must be in range 64-1200000"
            }
            else
              return "Cir must be in range 64-1200000"
        }
      }

      if(value == 3 || value == 0)
      {
        if(this.usForm.usPir != "")
        {
            let usPir = Number(this.usForm.usPir)
            if(!isNaN(usPir))
            {
                if(usPir < 64 || usPir > 1200000)
                return "Pir must be in range 64-1200000"
            }
            else
              return "Pir must be in range 64-1200000"
        }
      }

      if(value == 4 || value == 0)
      {
        if(this.usForm.usCbs != "")
        {
            let usCbs = Number(this.usForm.usCbs)
            if(!isNaN(usCbs))
            {
                if(usCbs < 2 || usCbs > 37500)
                return "Cbs must be in range 2-37500"
            }
            else
              return "Cbs must be in range 2-37500"
        }
      }

      if(value == 5 || value == 0)
      {
        if(this.usForm.usPbs != "")
        {
            let usPbs = Number(this.usForm.usPbs)
            if(!isNaN(usPbs))
            {
                if(usPbs < 2 || usPbs > 37500)
                return "Pbs must be in range 2-37500"
            }
            else
              return "Pbs must be in range 2-37500"
        }
      }

      if(value == 6 || value == 0)
      {
         var space=/[\s]/
        if (space.test(this.usForm.profileName)) return "Contains illegal characters."
        else
         return nonASCIIchar(this.usForm.profileName)
      }

      return null
    }
  },
}
</script>

<style>
.table_edit {
  position: absolute;
  top: 20%;
  left: 20%;
  z-index: 1;
  width: 50%;
}
</style>